import { getEndpoint } from './endpoints';
import axios from 'axios';

const TYPE_REQUEST_VE = 've';
const TYPE_REQUEST_VPT = 'vpt';
const TYPE_REQUEST_CONFORMITY_RAINY = 'conformite_rainy';
const TYPE_REQUEST_CONFORMITY_ONLY = 'conformite_only';

export const refSynthesis = {
    state: {
        type: 'synthesis',
        types: [],
        SynthesisStats: {
            veStats: [],
            vptStats: [],
            ccOnlyStats: [],
            ccRainyStats: [],
        },
    },
    actions: {
        async fetchSynthesisStats({ commit, rootState, state }) {

            const endpoint = getEndpoint(state.type).getDateHistogram;

            let currentYear = new Date().toISOString().slice(0, 4);
            let previousYear = currentYear - 1;

            let startDateFilter = previousYear + '-01-01';
            let endDateFilter = currentYear + '-12-31';
            // Data Query Params
            let paramsVE = { type: TYPE_REQUEST_VE, startDate: startDateFilter, endDate: endDateFilter };
            let paramsVPT = { type: TYPE_REQUEST_VPT, startDate: startDateFilter, endDate: endDateFilter };
            let paramsCCOnly = {
                type: TYPE_REQUEST_CONFORMITY_ONLY,
                startDate: startDateFilter,
                endDate: endDateFilter,
            };
            let paramsCCRainy = {
                type: TYPE_REQUEST_CONFORMITY_RAINY,
                startDate: startDateFilter,
                endDate: endDateFilter,
            };
            let formattedVeData = null;
            let formattedVptData = null;
            let formattedCCOnlyData = null;
            let formattedCCRainy = null;
            {
                // Get VE DATA
                let { data } = await rootState.app.http.instance.get(endpoint, {
                    params: paramsVE,
                });
                formattedVeData = formatStats(data);
            }
            {
                // Get VPT Data
                let { data } = await rootState.app.http.instance.get(endpoint, {
                    params: paramsVPT,
                });
                formattedVptData = formatStats(data);
            }
            {
                // Get CC Only
                let { data } = await rootState.app.http.instance.get(endpoint, {
                    params: paramsCCOnly,
                });
                formattedCCOnlyData = formatStats(data);
            }
            {
                // Get CC Rainy
                let { data } = await rootState.app.http.instance.get(endpoint, {
                    params: paramsCCRainy,
                });
                formattedCCRainy = formatStats(data);
            }
            const endpointUpdatedDate = getEndpoint(state.type).getLastUpdatedDate;
            {
                let { data } = await rootState.app.http.instance.get(endpointUpdatedDate);

                var lastSynthesisUpdatedDate = null;
                if ((data.lastUpdate || {}).date) {
                    lastSynthesisUpdatedDate = new Date(data.lastUpdate.date);
                    lastSynthesisUpdatedDate = lastSynthesisUpdatedDate.toLocaleDateString() + ' à ' + lastSynthesisUpdatedDate.toLocaleTimeString();
                }
            }
            var newURS = {
                lastUpdatedDate: lastSynthesisUpdatedDate,
                veStats: formattedVeData,
                vptStats: formattedVptData,
                ccOnlyStats: formattedCCOnlyData,
                ccRainyStats: formattedCCRainy,
            };

            commit('setSynthesisStats', newURS);
        },

        async fetchSynthesisTypes({ commit, rootState, state }) {

            const endpoint = getEndpoint(state.type).getTypes;

            // Get VE DATA
            var { data } = await rootState.app.http.instance.get(endpoint);

            commit('setSynthesisTypes', data);
        },
    },
    mutations: {
        submitSyntheseQuery(state, payload) {
            // TODO : USE THAT FOR DISPLAY SYNTHESIS IF NECESSARY
            const endpoint = getEndpoint('synthesis').getQuery + '.json?startDate=' + payload.startDate + '&endDate=' + payload.endDate + '&type=' + payload.type;

            axios.get(endpoint)
                .catch(error => {
                    console.log(error);
                });

        },
        setSynthesisTypes(state, payload) {
            state.types = payload;
        },
        setSynthesisStats(state, payload) {
            state.SynthesisStats = payload;
        },
        setVEStats(state, payload) {
            state.SynthesisStats.veStats = payload;
        },
    },
    getters: {
        getSynthesisStats(state) {
            return state.SynthesisStats;
        },
    },
};


function formatStats(data) {
    let currentYear = new Date().toISOString().slice(0, 4);
    let previousYear = currentYear - 1;

    var stats = {
        currentYear: new Array(),
        previousYear: new Array(),
    };

    // Create current year array
    var totalCurrentYear = 0;
    var totalPreviousYear = 0;
    for (var i = 1; i <= 12; ++i) {
        let monthCurrentYear = currentYear + '-' + (i < 10 ? '0' + i : i);
        let monthPreviousYear = previousYear + '-' + (i < 10 ? '0' + i : i);

        if (data.hasOwnProperty(monthCurrentYear)) {
            stats.currentYear.push(data[monthCurrentYear]);
            totalCurrentYear += parseInt(data[monthCurrentYear]);
        } else {
            stats.currentYear.push(0);
        }

        if (data.hasOwnProperty(monthPreviousYear)) {
            stats.previousYear.push(data[monthPreviousYear]);
            totalPreviousYear += parseInt(data[monthPreviousYear]);
        } else {
            stats.previousYear.push(0);
        }
    }

    // Add total values
    stats.currentYear.push(totalCurrentYear);
    stats.previousYear.push(totalPreviousYear);

    return stats;
}
